"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookiesNextProvider = exports.useReactiveCookiesNext = exports.useReactiveHasCookie = exports.useReactiveDeleteCookie = exports.useReactiveSetCookie = exports.useReactiveGetCookie = exports.useReactiveGetCookies = exports.useCookiesNext = exports.useDeleteCookie = exports.useGetCookie = exports.useSetCookie = exports.useHasCookie = exports.useGetCookies = exports.hasCookie = exports.deleteCookie = exports.setCookie = exports.getCookie = exports.getCookies = void 0;
var clientCookies = __importStar(require("./client"));
var serverCookies = __importStar(require("./server"));
__exportStar(require("./common/types"), exports);
var utils_1 = require("./common/utils");
var getCookies = function (options) {
    return (0, utils_1.isClientSide)(options) ? clientCookies.getCookies(options) : serverCookies.getCookies(options);
};
exports.getCookies = getCookies;
var getCookie = function (key, options) {
    return (0, utils_1.isClientSide)(options) ? clientCookies.getCookie(key, options) : serverCookies.getCookie(key, options);
};
exports.getCookie = getCookie;
var setCookie = function (key, data, options) {
    return (0, utils_1.isClientSide)(options) ? clientCookies.setCookie(key, data, options) : serverCookies.setCookie(key, data, options);
};
exports.setCookie = setCookie;
var deleteCookie = function (key, options) {
    return (0, utils_1.isClientSide)(options) ? clientCookies.deleteCookie(key, options) : serverCookies.deleteCookie(key, options);
};
exports.deleteCookie = deleteCookie;
var hasCookie = function (key, options) {
    return (0, utils_1.isClientSide)(options) ? clientCookies.hasCookie(key, options) : serverCookies.hasCookie(key, options);
};
exports.hasCookie = hasCookie;
var client_1 = require("./client");
Object.defineProperty(exports, "useGetCookies", { enumerable: true, get: function () { return client_1.useGetCookies; } });
Object.defineProperty(exports, "useHasCookie", { enumerable: true, get: function () { return client_1.useHasCookie; } });
Object.defineProperty(exports, "useSetCookie", { enumerable: true, get: function () { return client_1.useSetCookie; } });
Object.defineProperty(exports, "useGetCookie", { enumerable: true, get: function () { return client_1.useGetCookie; } });
Object.defineProperty(exports, "useDeleteCookie", { enumerable: true, get: function () { return client_1.useDeleteCookie; } });
Object.defineProperty(exports, "useCookiesNext", { enumerable: true, get: function () { return client_1.useCookiesNext; } });
Object.defineProperty(exports, "useReactiveGetCookies", { enumerable: true, get: function () { return client_1.useReactiveGetCookies; } });
Object.defineProperty(exports, "useReactiveGetCookie", { enumerable: true, get: function () { return client_1.useReactiveGetCookie; } });
Object.defineProperty(exports, "useReactiveSetCookie", { enumerable: true, get: function () { return client_1.useReactiveSetCookie; } });
Object.defineProperty(exports, "useReactiveDeleteCookie", { enumerable: true, get: function () { return client_1.useReactiveDeleteCookie; } });
Object.defineProperty(exports, "useReactiveHasCookie", { enumerable: true, get: function () { return client_1.useReactiveHasCookie; } });
Object.defineProperty(exports, "useReactiveCookiesNext", { enumerable: true, get: function () { return client_1.useReactiveCookiesNext; } });
Object.defineProperty(exports, "CookiesNextProvider", { enumerable: true, get: function () { return client_1.CookiesNextProvider; } });
